import createIcon from '../../createIcon';

/**
 * @component @name Face
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAxMS43NUM4LjMxIDExLjc1IDcuNzUgMTIuMzEgNy43NSAxM0M3Ljc1IDEzLjY5IDguMzEgMTQuMjUgOSAxNC4yNUM5LjY5IDE0LjI1IDEwLjI1IDEzLjY5IDEwLjI1IDEzQzEwLjI1IDEyLjMxIDkuNjkgMTEuNzUgOSAxMS43NVpNMTUgMTEuNzVDMTQuMzEgMTEuNzUgMTMuNzUgMTIuMzEgMTMuNzUgMTNDMTMuNzUgMTMuNjkgMTQuMzEgMTQuMjUgMTUgMTQuMjVDMTUuNjkgMTQuMjUgMTYuMjUgMTMuNjkgMTYuMjUgMTNDMTYuMjUgMTIuMzEgMTUuNjkgMTEuNzUgMTUgMTEuNzVaTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTIgMjBDNy41OSAyMCA0IDE2LjQxIDQgMTJDNCAxMS43MSA0LjAyIDExLjQyIDQuMDUgMTEuMTRDNi40MSAxMC4wOSA4LjI4IDguMTYgOS4yNiA1Ljc3QzExLjA3IDguMzMgMTQuMDUgMTAgMTcuNDIgMTBDMTguMiAxMCAxOC45NSA5LjkxIDE5LjY3IDkuNzRDMTkuODggMTAuNDUgMjAgMTEuMjEgMjAgMTJDMjAgMTYuNDEgMTYuNDEgMjAgMTIgMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Face = createIcon('Face', [
  [
    'path',
    {
      d: 'M9 11.75C8.31 11.75 7.75 12.31 7.75 13C7.75 13.69 8.31 14.25 9 14.25C9.69 14.25 10.25 13.69 10.25 13C10.25 12.31 9.69 11.75 9 11.75ZM15 11.75C14.31 11.75 13.75 12.31 13.75 13C13.75 13.69 14.31 14.25 15 14.25C15.69 14.25 16.25 13.69 16.25 13C16.25 12.31 15.69 11.75 15 11.75ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 11.71 4.02 11.42 4.05 11.14C6.41 10.09 8.28 8.16 9.26 5.77C11.07 8.33 14.05 10 17.42 10C18.2 10 18.95 9.91 19.67 9.74C19.88 10.45 20 11.21 20 12C20 16.41 16.41 20 12 20Z',
      key: 'ikh158',
    },
  ],
]);

export default Face;
